import { ColDef } from "ag-grid-community";
import { k8sMonthlyPriceColumnDef } from "./common/k8sMonthlyPriceColumnDef";
import { k8sClusterColumnDef } from "./common/k8sClusterColumnDef";
import { k8sAgeColumnDef } from "./common/k8sAgeColumnDef";
import { k8sLabelsColumnDef } from "./common/k8sLabelsColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";

export const k8sJobColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Job Name"),

  k8sMonthlyPriceColumnDef,

  k8sClusterColumnDef,

  k8sAgeColumnDef,

  { field: "resource.namespace", headerName: "Namespace" },

  k8sLabelsColumnDef,
];
